import React from 'react';
import styled from 'styled-components';
import { useAppAgendaContext } from '../context/AppAgendaContext';

const Panel = styled.div`
  position: fixed;
  bottom: 12px;
  right: 12px;
  background-color: #ffffffee;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  font-size: 13px;
  color: #333;
  z-index: 9999;
  max-width: 350px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: monospace;
`;

const Section = styled.div`
  margin-bottom: 12px;
`;

const DebugPanel = () => {
  const {
    pasoActual,
    utmData,
    ultimoEventoGTM,
    sessionId,
    contextData,
    eventosLog
  } = useAppAgendaContext();

  return (
    <Panel>
      <Section>
        <strong>📍 Paso Actual:</strong><br />
        {pasoActual || 'No definido'}
      </Section>

      <Section>
        <strong>🧾 Session ID:</strong><br />
        {sessionId}
      </Section>

      <Section>
        <strong>📊 UTM Capturados:</strong><br />
        <div>source: {utmData?.source || '-'}</div>
        <div>medium: {utmData?.medium || '-'}</div>
        <div>campaign: {utmData?.campaign || '-'}</div>
        <div>term: {utmData?.term || '-'}</div>
        <div>content: {utmData?.content || '-'}</div>
      </Section>

      <Section>
        <strong>🖥️ Dispositivo:</strong><br />
        <div>Tipo: {contextData?.dispositivoTipo || '-'}</div>
        <div>SO: {contextData?.sistemaOperativo || '-'}</div>
        <div>Navegador: {contextData?.navegador || '-'}</div>
      </Section>

      <Section>
        <strong>📤 Último Evento GTM:</strong><br />
        {ultimoEventoGTM || 'Ninguno'}
      </Section>

      <Section>
        <strong>🧑‍⚕️ RUT Paciente:</strong><br />
        {contextData?.pacRut || 'No ingresado'}
      </Section>

      <Section>
        <strong>📝 Últimos Eventos:</strong><br />
        {eventosLog.length === 0 ? (
          <div>-</div>
        ) : (
          eventosLog.map((e, idx) => (
            <div key={idx} style={{ marginBottom: '4px' }}>
              <strong>{e.paso}</strong> - {e.evento}<br />
              <em>{e.descripcion}</em> ({e.timestamp})
            </div>
          ))
        )}
      </Section>
    </Panel>
  );
};

export default DebugPanel;
